export default [
  {
    details: {
      firstName: 'Xchart',
      lastName: 'Support',
      name: 'Xchart Support',
    },
    apiId: 'support',
  },
  {
    details: {
      firstName: 'Henrik',
      lastName: 'Joreteg',
    },
    apiId: 'henrik',
  },
  {
    details: {
      firstName: 'Travis',
      lastName: 'Coulter',
    },
    apiId: 'travis',
  },
  {
    details: {
      firstName: 'Miranda',
      lastName: 'Moquist',
    },
    apiId: 'miranda',
  },
]
